export const languages = [
    { id: 0, key: 'en', flagIcon: 'flag-icon-gb', text: 'English' },
    { id: 1, key: 'fr', flagIcon: 'flag-icon-fr', text: 'Français' },
    { id: 2, key: 'nl', flagIcon: 'flag-icon-nl', text: 'Nederlands' }
];